import React from 'react';
import ChangeNameForm from './change_name_form';

const ParentChangeName = () => {
  return <ChangeNameForm onSuccessRoute="/my-account" />;
};

export default ParentChangeName;
